
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import React, { Component } from "react";

// reactstrap components
import {
  CardText,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";
// core components
import AuthHeader from "../../../components/Headers/AuthHeader";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import connect from 'redux-connect-decorator';
import { getTopStudents } from '../../../actions/topStudentActions';

@connect(
  state => ({
    topStudents: state.topStudent.topStudents,
    loading: state.topStudent.loading
  }),
  {
    getTopStudents
  }
)
class Student extends Component<any, any> {
  componentDidMount() {
    this.props.getTopStudents();
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 3000,
      cssEase: "linear"
    };

    const { topStudents } = this.props;

    return (
      <>
        <AuthHeader title="HỌC VIÊN THÀNH CÔNG" lead="" />
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="10">
              <Card>
                <CardBody>
                    <div className="order-md-2 mb-4" style={{ width: '600px', height : '300px', margin: 'auto'}}>
                      { topStudents && <Slider {...settings}>
                        {topStudents.map((item, i) => (
                          <div key={`top-student-${i}`} >
                            <img style={{ height : '300px'}} src={item.img_url } />
                          </div>
                        ))
                        }
                      </Slider>
                      }
                    </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Student;
